import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=02699960&"
import script from "./LocaleSelect.vue?vue&type=script&lang=js&"
export * from "./LocaleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports